import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
const AUTH_URL = process.env.REACT_APP_AUTH_URL;
console.log(AUTH_URL)
// Create the context
const UserContext = createContext();

// Create the provider component
export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
   
  useEffect(() => {
    const storedToken = localStorage.getItem("access_token") || sessionStorage.getItem("access_token"); // if rememberMe was checked.
    console.log("🔍 UserContext: Stored token:", storedToken ? "Found" : "Not found");
    console.log("🔍 UserContext: AUTH_URL:", AUTH_URL);
    
    if (storedToken) {
      // If we have the access token, make a request to get the user info
      const fetchUser = async () => {
        try {
          console.log("🔍 UserContext: Fetching user data from:", `${AUTH_URL}/api/auth/me/`);
          const response = await axios.get(`${AUTH_URL}/api/auth/me/`, {
            headers: { Authorization: `Bearer ${storedToken}` }
          });
          console.log("🔍 UserContext: User response:", response.data);
          setUser({
            username: response.data.username,
            email: response.data.email,
            colorhex: response.data.usercolorhex,
            id: response.data.id
          });
        } catch (error) {
          console.error("❌ UserContext: Error fetching user data:", error);
          console.error("❌ UserContext: Error details:", error.response?.data || error.message);
          setUser(null); // Reset user if there's an error fetching user data
        }
      };

      fetchUser();
    } else {
      console.log("🔍 UserContext: No token found, setting user to null");
      setUser(null); // No token means no user
    }
  }, []); // This effect only runs once on mount (when the app loads or refreshes)
  console.log(user);
  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
};

// Custom hook for easy use of user context
export const useUser = () => useContext(UserContext);